<template lang="pug">
    div
        Button(
            @click="alertRuleTest" 
            type="primary" 
            :loading="isLoading" 
            shape="circle"
            icon="ios-play"
        )
        Modal(
            :title="ruleData.ruleName"
            v-model="showResult"
        )
            p Query: {{ testResult.alertRuleQuery }}
            p Alert when: {{ testResult.alertWhen }} {{ testResult.alertValue }} {{ testResult.alertValueUnit }}
            p CurrentValue: {{ testResult.currentValue }}
            strong Alerting:  {{ testResult.isAlerting }}
            Divider
            h3 Message: 
            p(style="white-space: pre-wrap;") {{ testResult.alertMessageTransform }}
</template>

<script>
import { _alertRuleTest } from "@/api/alertrules";
export default {
    name: "RuleTestBtn",
    components: {},
    data() {
        return {
            isLoading: false,
            showResult: false,
            testResult: {}
        };
    },
    props: { ruleData: {} },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        alertRuleTest() {
            var self = this;
            this.isLoading = true;
            _alertRuleTest(this.ruleData)
                .then(res => {
                    self.testResult = res.data;
                    self.isLoading = false;
                    self.showResult = true;
                })
                .catch(err => {
                    self.isLoading = false;
                    console.log(err);
                    self.$Notice.warning({
                        title: "Failed",
                        desc: `${err.message}`
                    });
                });
        }
    },
    computed: {},
    beforeDestroy() {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/AlertRules/RuleTestBtn.vue